import { render, staticRenderFns } from "./TicketDetail.vue?vue&type=template&id=55582cb0&scoped=true"
import script from "./TicketDetail.vue?vue&type=script&lang=js"
export * from "./TicketDetail.vue?vue&type=script&lang=js"
import style0 from "./TicketDetail.vue?vue&type=style&index=0&id=55582cb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55582cb0",
  null
  
)

export default component.exports